import { render, staticRenderFns } from "./WapProductWarehouseIn.vue?vue&type=template&id=5a6d06ad&"
import script from "./WapProductWarehouseIn.vue?vue&type=script&lang=js&"
export * from "./WapProductWarehouseIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports